import Spring from './Spring.vue';

export default Spring;
